const ADMIN_PANEL_USERS_PATH = "/panel/user";

const normalizeApiDomain = (apiDomain = "") =>
  apiDomain.replace(/\/api\/?$/, "").replace(/\/$/, "");

export const getAdminPanelUsersUrl = (apiDomain = "") =>
  `${normalizeApiDomain(apiDomain)}${ADMIN_PANEL_USERS_PATH}`;
